import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Text } from '@oneaudi/unified-web-components';
import React, { Fragment, memo } from 'react';
import styled from 'styled-components';
import { useContent } from '../context/ContentContext';
import { useFeatureAppEnv } from '../context/FeatureAppEnvContext';
import { useI18n } from '../i18n';

const PriceWrapper = styled.span`
  display: inline;
  white-space: normal;
  word-break: break-word;
  > span + span {
    margin-left: 1ch;
  }
`;

const StyledPrice = styled(Text)`
  white-space: normal;
`;

export type PriceProps = {
  readonly value?: number;
};

export const Price = memo(function Price({ value }: PriceProps) {
  const { 'audi-number-formatter-service': numberFormatterService } =
    useFeatureAppEnv().featureServices;
  const {
    priceFootnotes,
    priceDisplayOption: { showBasePrice, showVat },
  } = useContent();

  if (!showBasePrice || value === undefined) {
    return null;
  }
  const orderSize = '2';
  const fontWeight = process.env.IS_LEGACY ? 'normal' : 'bold';
  return (
    <PriceWrapper>
      <StyledPrice
        variant={{
          order: orderSize,
          style: fontWeight,
          type: 'copy',
        }}
        data-testid="price"
        tag="span"
      >
        {useI18n('priceFrom', { value: numberFormatterService.formatCurrency(value) })}
        {priceFootnotes?.map((footnote: string, i: number) => (
          <Fragment key={footnote}>
            {i > 0 && <sup>{', '}</sup>}
            <FootnoteReferenceV2
              footnoteId={footnote}
              footnoteAriaLabel="price"
              data-testid={`price-footnote_${i}`}
            />
          </Fragment>
        ))}
      </StyledPrice>
      {showVat && (
        <StyledPrice
          variant={{
            order: orderSize,
            style: fontWeight,
            type: 'copy',
          }}
          tag="span"
        >
          {useI18n('vat')}
        </StyledPrice>
      )}
    </PriceWrapper>
  );
});
